<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Donation Amount">
            <div style="position: relative">
              <AmountSelector />
              <ErrorLabel field="amount" style="text-align: right" />
            </div>
            <div class="frequency">
              <PaymentOptions addMonthly monthesSelector/>
            </div>
          </FormSection>
          <FormSection v-if="form.amount">
            <TransactionFee />
          </FormSection>
          <FormSection>
            <InHonorOf />
          </FormSection>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                   
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton btnText="Donate Now" showAmount />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { setValue, form } = usePaymentForm();

    return {
      form,
      setValue,
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep h2 {
  color: #1aa8d3;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 25px;
  position: relative;
  &:not(:empty) {
    &::before {
      content: "*";
      color: #e87d2d;
      margin-right: 3px;
    }
  }
}
</style>
